import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/AuthContext";
import { SubjectsProvider } from "./lib/SubjectsContext";
import { LanguageProvider } from "./lib/LanguageContext";
import { CartProvider } from "./lib/CartContext";
import { Toaster } from "sonner";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import AboutPage from "./pages/About";
import ProductsPage from "./pages/Products";
import CheckoutPage from "./pages/Checkout";
import EducationPage from "./pages/Education";
import NunaDashboard from "./pages/Nuna";
import FFQPage from "./pages/FFQ";
import PricingPage from "./pages/Pricing";
import PrintPage from "./pages/Print";
import PaymentSimulate from "./pages/PaymentSimulate";
import AdminVouchers from "./pages/AdminVouchers";
import { LoginPage, RegisterPage } from "./pages/Auth";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <SubjectsProvider>
      <CartProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <NavBar/>
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing/>}/>
              <Route path="/tentang" element={<AboutPage/>}/>
              <Route path="/produk" element={<ProductsPage/>}/>
              <Route path="/keranjang" element={<CheckoutPage/>}/>
              <Route path="/edukasi" element={<EducationPage/>}/>
              <Route path="/nuna" element={<NunaDashboard/>}/>
              <Route path="/nuna/print/:id" element={<PrintPage/>}/>
              <Route path="/ffq" element={<FFQPage/>}/>
              <Route path="/harga" element={<PricingPage/>}/>
              <Route path="/masuk" element={<LoginPage/>}/>
              <Route path="/daftar" element={<RegisterPage/>}/>
              <Route path="/payment/success" element={<PaymentSuccess/>}/>
              <Route path="/payment/cancel" element={<PaymentCancel/>}/>
              <Route path="/payment/simulate" element={<PaymentSimulate/>}/>
              <Route path="/admin/vouchers" element={<AdminVouchers/>}/>
            </Routes>
          </main>
          <Footer/>
          <Toaster position="bottom-right" richColors closeButton/>
        </div>
      </BrowserRouter>
      </CartProvider>
      </SubjectsProvider>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
